import { SVGProps } from 'react';

export type BlueShieldCheckmarkProps = SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};

export const BlueShieldCheckmark = ({
  size = 20,
  color = '#3A5BC7',
  ...props
}: BlueShieldCheckmarkProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.77224 1.42463C9.55042 1.19179 9.19958 1.19179 8.97776 1.42463C8.00559 2.44512 7.13913 3.01327 6.23447 3.33549C5.31966 3.66133 4.32748 3.75 3.07292 3.75H2.5V11.6915C2.5 13.1873 3.20052 14.5794 4.35732 15.3825L9.06742 18.6523C9.25508 18.7826 9.49492 18.7826 9.68258 18.6523L14.3927 15.3825C15.5495 14.5794 16.25 13.1873 16.25 11.6915V3.75H15.6771C14.4225 3.75 13.4303 3.66133 12.5155 3.33549C11.6109 3.01327 10.7444 2.44512 9.77224 1.42463ZM14.1004 6.83709C13.7343 6.47097 13.1407 6.47097 12.7746 6.83709L8.4375 11.1742L6.60041 9.33709C6.2343 8.97097 5.6407 8.97097 5.27459 9.33709C4.90847 9.7032 4.90847 10.2968 5.27459 10.6629L7.77459 13.1629C8.1407 13.529 8.7343 13.529 9.10041 13.1629L14.1004 8.16291C14.4665 7.7968 14.4665 7.2032 14.1004 6.83709Z"
      fill={color}
    />
  </svg>
);
